// Product catalogue filtering (species groups).
document.addEventListener('DOMContentLoaded', () => {
  const filters = Array.from(document.querySelectorAll('[data-filter]'));
  const products = Array.from(document.querySelectorAll('[data-group]'));
  if (!filters.length || !products.length) return;

  const apply = (value) => {
    filters.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.filter === value));
    });
    products.forEach((product) => {
      const groups = (product.dataset.group || '').split(/\s+/);
      product.hidden = value !== 'all' && !groups.includes(value);
    });
  };

  filters.forEach((button) => {
    button.addEventListener('click', () => apply(button.dataset.filter));
  });
  apply('all');
});
